import api from './api';

export type Item = {
  id?: string;
  metaId: string;
  titulo?: string;
  descricao?: string;
  tipo?: 'CUSTEIO' | 'INVESTIMENTO' | string;
  unidade?: string;
  quantidade?: number;
  periodoInicio?: string;
  periodoFim?: string;
  valorUnitario?: number;
  valorFornecedor01?: number;
  valorFornecedor02?: number;
  valorFornecedor03?: number;
  valor?: number; // total
  periodo?: string;
  dataCriacao?: string;
  dataAtualizacao?: string;
};

const base = '/item';

export const listByMeta = async (metaId: string): Promise<Item[]> => {
  const res = await api.get(`${base}/meta/${metaId}`);
  return res.data;
};

export const create = async (payload: Item): Promise<Item> => {
  const res = await api.post(base, payload);
  return res.data;
};

export const update = async (id: string, payload: Item): Promise<Item> => {
  const res = await api.put(`${base}/${id}`, payload);
  return res.data;
};

export const remove = async (id: string): Promise<void> => {
  await api.delete(`${base}/{id}`.replace('{id}', id));
};

export default { listByMeta, create, update, remove };
